import { render, staticRenderFns } from "./propertyEdit.vue?vue&type=template&id=c9dc892a&scoped=true&"
import script from "./propertyEdit.vue?vue&type=script&lang=js&"
export * from "./propertyEdit.vue?vue&type=script&lang=js&"
import style0 from "./propertyEdit.vue?vue&type=style&index=0&id=c9dc892a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dc892a",
  null
  
)

export default component.exports